import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import Router from './Router';

function App() {
  return (
    <BrowserRouter>
      {/* <StorageEngine /> */}
      <Router />
    </BrowserRouter>
  );
}

serviceWorker.register();

export default App;



// WEBPACK FOOTER //
// ./src/App.js